import { gql } from '@apollo/client';

export const GET_APPROVAL_ROUTE_TEMPLATES = gql`
  query GET_APPROVAL_ROUTE_TEMPLATES($ids: [ID!], $state: State) {
    approvalRouteTemplates(ids: $ids, state: $state) {
      id
      name
      description
      disabled
      approvalStepTemplates {
        sequence
        name
        approverListingType
        appointedApprover {
          role {
            id
          }
          specifiedFaculty
          faculty {
            id
          }
          specifiedDepartment
          department {
            id
          }
        }
      }
    }
  }
`;

export const ADD_APPROVAL_ROUTE_TEMPLATE = gql`
  mutation ADD_APPROVAL_ROUTE_TEMPLATE($input: AddApprovalRouteTemplateInput) {
    addApprovalRouteTemplate(input: $input) {
      id
      name
    }
  }
`;

export const UPDATE_APPROVAL_ROUTE_TEMPLATE = gql`
  mutation UPDATE_APPROVAL_ROUTE_TEMPLATE(
    $input: UpdateApprovalRouteTemplateInput
  ) {
    updateApprovalRouteTemplate(input: $input) {
      id
      name
    }
  }
`;

export const ASSIGN_APPOINTED_APPROVER = gql`
  mutation ASSIGN_APPOINTED_APPROVER($input: AssignAppointedApproverInput) {
    assignAppointedApprover(input: $input) {
      __typename
      ... on ApprovalStep {
        name
      }
      ... on FormSection {
        name
      }
    }
  }
`;
